export const getFileNameFromDate = (
  dateString: string,
  id: string,
  extension: string
) => {
  const dateName = dateString.replace(/:/g, '_')
  const fileNameSplit = dateName.replace(/\./g, '_')
  return `${fileNameSplit}-${id}.${extension}`
}

export const getFileNameFromDateV2 = (dateString: string, fileName: string) => {
  const dateName = dateString.replace(/:/g, '_')
  const fileNameSplit = dateName.replace(/\./g, '_')
  return `${fileNameSplit}-file-${fileName?.replace(/ /g, '-')}`
}
